import { CurrencyPipe, DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { Column } from '@shared/components/data-view/data-view-types';
import { GridColumn } from '@shared/models/grid-column.model';
import { StatusLabelPipe } from '@shared/pipes/status-label.pipe';
import { TimeDurationPipe } from '@shared/pipes/time-duration.pipe';
import { get } from 'lodash';

@Pipe({
  name: 'gridField',
  standalone: true,
})
export class GridFieldPipe implements PipeTransform {
  private datePipe = inject(DatePipe);
  private currencyPipe = inject(CurrencyPipe);
  private statusLabelPipe = inject(StatusLabelPipe);
  private timeDurationPipe = inject(TimeDurationPipe);

  transform(item: unknown, column: GridColumn | Column.AppliedDataViewColumn): null | string {
    const value = get(item, column.field);
    let result: null | string;

    if (column.type === 'date') {
      result = this.datePipe.transform(this.stripTimeComponent(value), 'MM/dd/yyyy');
    } else if (column.type === 'daterange') {
      result =
        value?.startDate && value?.endDate
          ? `${this.datePipe.transform(this.stripTimeComponent(value.startDate), 'MM/dd/yyyy')} - ${this.datePipe.transform(this.stripTimeComponent(value.endDate), 'MM/dd/yyyy')}`
          : null;
    } else if (column.type === 'datetime') {
      result = this.datePipe.transform(value, 'MM/dd/yyyy hh:mm a');
    } else if (column.type === 'datetimerange') {
      result =
        value?.startDate && value?.endDate
          ? `${this.datePipe.transform(value.startDate, 'MM/dd/yyyy')} - ${this.datePipe.transform(value.endDate, 'MM/dd/yyyy')}`
          : null;
    } else if (column.type === 'datetimeprecise') {
      result = this.datePipe.transform(value, 'MM/dd/yyyy hh:mm:ss a');
    } else if (column.type === 'time') {
      result = this.datePipe.transform(value, 'hh:mm a');
    } else if (column.type === 'timeprecise') {
      result = this.datePipe.transform(value, 'hh:mm:ss a');
    } else if (column.type === 'duration') {
      result = value ? `${value}s` : null;
    } else if (column.type === 'timeDuration') {
      result = this.timeDurationPipe.transform(value);
    } else if (column.type === 'currency') {
      result = this.currencyPipe.transform(value, 'USD');
    } else if ('pipe' in column && column.pipe?.name === 'statusLabel') {
      result = this.statusLabelPipe.transform(value, column.pipe.arguments);
    } else {
      result = value;
    }

    return result;
  }

  private stripTimeComponent(value: string | number | Date): string | number | Date {
    if (typeof value === 'string') {
      return value.split('T')[0];
    }
    if (value instanceof Date) {
      return `${value.getUTCFullYear()}-${String(value.getUTCMonth() + 1).padStart(2, '0')}-${String(value.getUTCDate()).padStart(2, '0')}`;
    }
    return value;
  }
}
